function isQueryParamTrue(param: string) {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const paramValue = urlSearchParams.get(param);
    return paramValue === 'true';
}

export default isQueryParamTrue;
